import React, { useState } from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import uuid from '../../UniqueHash';
import { useModal } from '../../../../../../hooks/Modal';
import FormComponent, { sanitizeDataObject } from '../../FormComponent';
import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';
import getValidationErrors from '../../../../../../utils/getValidationErrors';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import { AxiosInstance } from 'axios';
import { FaEdit, FaEye } from 'react-icons/fa';
import { Field } from '../../../../../../components/QuizzComponent/styles';
import CheckboxInput from '../../Forms/CheckboxInput';
import { Form } from '@unform/web';

interface ICreateModule {
  lineData: Record<string, any>;
  title: string;
  formSchema: Record<string, any>;
  endpoint: string;
  validationSchema: Record<string, IYup>;
  apiRef ?: AxiosInstance,
}

interface IQuestion {
  id : string;
  label : string;
  value: string;
}

export default function UpdateModule({
  apiRef = api,
  lineData,
  title,
  formSchema,
  validationSchema,
  endpoint,
}: ICreateModule): JSX.Element {
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();

  let selectedOptionVote = '';
  const key = uuid();






  const selectOption = (questionObj, value: string) => {
 
      const vote: Array<string> = [];
   
      selectedOptionVote = value;
    

   
  };

  const sendVote = async (data) => {

    const {answer} = data;

    const value = answer?.[0] || '';
    


    if (value === '') {
      return addToast({
        type: 'error',
        title: 'Vote em ao menos 1 das alternativas',
      });
    }

    const dataRef = {
      answers: [value],
      id : lineData.id,
    };
    try {
      const response = await api.post('/quizz_answer', dataRef);
      if (response.status !== 200) {
        return addToast({ type: 'error', title: 'Erro ao votar' });
      }

      removeModal('votacao')
     

      addToast({ type: 'success', title: 'Enviado com sucesso' });
    } catch (err) {
      return addToast({ type: 'error', title: err.response.data.error || err.response.data.message });
    }
  };

  const read = (questionObj,key) => {

    const answers : Array<IQuestion> = [];

    questionObj.questions.map( q => {
      answers.push({ id: q.value, value: q.value, label: q.value});
    }) 

    return (
      <>
        <p style={{color: '#333'}}>Pergunta</p>
        <h2 style={{color: '#333'}}>{questionObj.title}</h2>
        <p style={{color: '#333'}}>Opções</p>
       <Form onSubmit={sendVote}>
            <Field>
             <CheckboxInput color="#333" unique name={'answer'} options={answers} />
            </Field>
      

        <button style={{margin:'20px auto'}}
     
          className="defaultButton"
        >
          Enviar
        </button>
        </Form>
      </>
    );
  };

  const getQuestionToVote = async item => {

    try{
    const response = await api.post(`/assinar-question/${item.id}`);
    addToast({ type: 'success', title: 'Assinado com sucesso' });
    reloadSearchAll();

  } catch (err) {
    return addToast({ type: 'error', title: err.response.data.error || err.response.data.message });
  }

    
    }


  const moduleUpdate = (lineData): JSX.Element => (
    <button
    title="Visualizar Pergunta"
    onClick={() => getQuestionToVote(lineData)}
    type="button"
    className="defaultButtonMini"
  >
    Assinar
  </button>
  );

  return moduleUpdate(lineData);
}
